<template>
    <div class="screenshots" id="prev">
        <h1>App Screenshots</h1>
        <div class="slider-wrapper">
            <div :class="curSlide == item.id ? 'slide' : 'slide hidden'" v-for="item in slides" :key="item.id" :id="'slide-' + item.id">
                <img :src="item.img"/>
            </div>
            <div class="counter">
                <div :class="curSlide == item.id ? 'point selected' : 'point'" v-for="item in slides" :key="item.id" @click="changeSlideTo(item.id)"/>
            </div>
        </div>
        <h1 class="appvidhead">App Video</h1>
        <div class="mobilvid">
            <!--video controls="true" preload="auto" id="mobilevidwizy" class="mobile-video" muted>
            <source src="../assets/mobileVid.mp4" type="video/mp4"-->
            <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/369788091?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
        </div>
    </div>
</template>

<script src="https://player.vimeo.com/api/player.js"></script>
<script>
export default {
  name: "Facts",
  data(){
      return{
          slides: [
              {
                  id: 0,
                  desc: "Explore the world around you! Visit Sights, Restaurants or even call a taxi by just one click!",
                  img: require('@/assets/exploreScreen.png')
              },
              {
                  id: 1,
                  desc: "Save your Loyalty-Cards, scan every invoice and get back your tax!",
                  img: require('@/assets/pocketScreen.png')
              },
              {
                  id: 2,
                  desc: "Pay everywhere with every currency by just one click with Wizy!",
                  img: require('@/assets/paymentScreen.png')
              }
          ],
          curSlide: 0,
          changeSlideActive: true
      }
  },
  mounted(){
      document.getElementById('slide-'+this.curSlide).className="slide fadein";    
      window.setInterval(this.changeSlide,4000);
  },
  methods:{
      changeSlide(){
          if(this.changeSlideActive){
            document.getElementById('slide-'+this.curSlide).className="slide fadeout";    
                window.setTimeout(() => {
                    document.getElementById('slide-'+this.curSlide).className="slide hidden";    
                    this.curSlide+=1;
                    if(this.curSlide >= this.slides.length){
                        this.curSlide = 0;
                    }
                    window.setTimeout(()=>{
                        document.getElementById('slide-'+this.curSlide).className="slide fadein";    
                    },10);
                }, 500);
          }
      },
      changeSlideTo(num){
        this.changeSlideActive = false
        document.getElementById('slide-'+this.curSlide).className="slide fadeout";   
        window.setTimeout(() => {
            document.getElementById('slide-'+this.curSlide).className="slide hidden";    
            this.curSlide=num;
            if(this.curSlide >= this.slides.length){
                this.curSlide = 0;
            }
            window.setTimeout(()=>{
                document.getElementById('slide-'+this.curSlide).className="slide fadein";    
            },10);
        }, 50);
        window.setTimeout(() => {
            this.changeSlideActive = true;
        }, 10000)
      }
  }
};
</script>

<style lang="scss" scoped>
.appvidhead{
    @media(min-width: 780px){
        display:none;
    }
}
.mobilvid{
    max-width: 80%;
    margin: 0 auto;
    text-align: center;
    #mobilevidwizy{
        max-width: 100%;
    }
    @media(min-width: 780px){
        display:none;
    }
}
.screenshots{
    margin-bottom: 30%;
    @media(min-width: 780px){
        margin-bottom: 10%;
    }
    h1{
        font-size: 2rem;
        font-weight: bold;
        text-align: center;
        margin: 1%;
        margin-bottom: 5%;
        @media(max-width: 780px){
            padding-top: 10%;
        }
    }
    .counter{
        text-align: center;
        .point{
            margin: 1%;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 10px;
            border: 2px solid lightgrey;
            &.selected{
                background-color: rgb(54,209,220);
                border: 2px solid rgb(54,209,220);
            }
        }
    }
    .slider-wrapper{
        @media(min-width: 780px){
            width: 60%;
        }
        margin: 0 auto;
        overflow: hidden;
        .slide{
            text-align: center;
            opacity: 0;
            h2{
                color: rgb(107,115,122);
                margin-bottom: 5%;
                font-weight: 500;
            }
            img{
                width: 80%;
                max-width: 1000px;
            }
            &.fadein{
                transition: opacity 0.5s ease-in;
                opacity: 1;
            }
            &.fadeout{
                transition: opacity 0.5s ease-out;
                opacity: 0;
            }
            &.hidden{
               display: none;
            }
        }
    }
}
</style>
